import mutationHelpers from '../../utils/mutation-helpers';
import axios from 'axios';

const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  nextUrl: null,
  total: null,
  errors: []
};

const getters = {
  getWishlistById: state => id => {
    return state.items.find(o => {
      return o.id === parseInt(id, 10);
    });
  },
  getItemsById: state => id => {
    const wishlist = state.items.find(o => {
      return o.id === parseInt(id, 10);
    });

    return wishlist ? wishlist.items : [];
  },
  getWishlists: state => () => {
    return state.items;
  }
};

const actions = {
  FETCH_WISHLISTS: async () => {},
  FETCH_MORE_WISHLISTS: async () => {},
  FETCH: async ({ commit, dispatch }, { id }) => {
    if (id) {  
      try {
        commit('UPDATE_STATUS', 'loading');
        const { data: { item: wishlist } } = await axios.get(`${path}/api/user/${id}/wishlist`);
        commit('UPDATE_STATUS', 'success');
        commit('ADD_ITEM', wishlist);
  
        return wishlist;
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch item. try again later.',
          { root: true }
        );
      }
    } else {
      console.error('you are not logged in.');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'please log in to view your collection',
        { root: true }
      );
    }
  },
  FETCH_ITEMS: async ({ commit, dispatch }, payload) => {
    try {
      const {
        data: {
          data: { items },
          links,
          meta
        }
      } = await axios.get(
        `${path}/api/user/${payload.id}/wishlist/items/${
          payload.num
        }`
      );

      commit('SET_ITEMS', {
        id: payload.id,
        items: items,
        links: links,
        meta: meta
      });
    } catch (error) {
      commit('SET_ERROR', error);
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'could not fetch items. try again later.',
        { root: true }
      );
    }
  },
  FETCH_MORE_ITEMS: async () => {},
  UPDATE_WISHLIST: async () => {}
};

const mutations = {
  SET_WISHLISTS: (state, data) => {
    state.items = data.data.items;
    state.nextUrl = data.links.next;
    state.total = data.meta.total;
  },
  ADD_WISHLISTS: (state, data) => {
    state.items = state.items.concat(data.data.items);
    state.nextUrl = data.links.next;
  },
  ADD_WISHLIST: (state, data) => {
    state.items = state.items.concat(data);
  },
  UPDATE_WISHLIST: (state, data) => {
    // fetch next "page" of groups that belong to the wishlist
    state.items = state.items.map(o => {
      o.id === parseInt(data.id, 10);
      o.name = data.name;
      o.description = data.description;

      return o;
    });
  },
  SET_ITEMS: (state, data) => {
    state.items = state.items.map(o => {
      if (o.id === parseInt(data.id, 10)) {
        o.items = {
          items: data.items,
          nextUrl: data.links.next
        };

        return o;
      }
      return o;
    });
  },
  ADD_ITEMS: (state, data) => {
    state.items = state.items.map(o => {
      if (o.id === parseInt(data.id, 10)) {
        o.items.items = o.items.items.concat(data.items);
        o.items.nextUrl = data.links.next;

        return o;
      }
      return o;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: { ...mutationHelpers, ...mutations }
};
